<template>
  <div id="shipments-print" class="text-center">
    <BreadCrumb class="d-print-none" :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1 d-print-none">
      <div v-if="!loading" class="d-flex justify-space-between align-center px-9 pb-6">
        <h1>Imprimir canhotos</h1>
        <v-btn color="primary" @click="printReceipts()">
          Imprimir
          <v-icon right dark> mdi-printer </v-icon>
        </v-btn>
      </div>

      <div class="d-flex flex-column align-center pt-2" v-if="loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="py-4">Carregando canhotos...</p>
      </div>
      <div v-else class="print-wrapper d-flex justify-center" v-for="canhoto in nfeCanhotos" :key="canhoto.id">
        <v-btn :disabled="nfeCanhotos.length === 1" @click="removeReceipt(canhoto.id)" icon color="red" class="mb-3">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
        <img class="pa-2 print-image" :src="canhoto.srcImage" :alt="canhoto.name" />
        <v-btn :disabled="nfeCanhotos.length === 1" @click="refreshImage(canhoto)" icon color="secondary" class="mb-3">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
      <div v-if="!loading && nfeCanhotos.length === 0" class="d-flex justify-center">
        <p>Nenhum canhoto encontrado!</p>
      </div>
    </v-card>
    <div class="wrapper-to-print" v-for="canhoto in nfeCanhotos" :key="canhoto.id">
      <img class="pa-2 print-image" :src="canhoto.srcImage" :alt="canhoto.name" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import Base64Mixin from '../../../mixins/base64.mixin';
import { baseURL } from '@/api/index';

export default {
  name: 'ShipmentsPrint',
  mixins: [Base64Mixin],
  components: {
    BreadCrumb
  },
  data: () => ({
    nfes: [],
    nfeCanhotos: [],
    error500: null,
    errors: [],
    errorsType: null,
    loading: true,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Embarques',
        disabled: false,
        to: '/shipments',
        exact: true
      },
      {
        text: 'Imprimir canhotos',
        disabled: true
      }
    ]
  }),
  computed: {
    ...mapGetters('NfeStore', ['getSelectedChecbox'])
  },
  mounted() {
    this.fetchAll();
  },
  methods: {
    ...mapActions('ShipmentStore', ['getReceiptsByHierarchies']),
    ...mapActions('NfeStore', ['getSrcImage']),
    voltar() {
      this.$router.back();
    },
    removeReceipt(id) {
      this.nfeCanhotos = this.nfeCanhotos.filter((item) => item.id !== id);
    },
    async refreshImage(canhoto) {
      try {
        const urlImage = `${baseURL}pt/${canhoto.linkDownload}`;
        const downloadLink = await this.getSrcImageCanhoto(urlImage);

        try {
          const dataFile = await this.toBase64(downloadLink);

          const index = this.nfeCanhotos.indexOf(canhoto);
          this.nfeCanhotos[index].srcImage = dataFile;
        } catch (e) {
          console.error(e);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchAll() {
      this.loading = true;
      const body = {
        stopIds: this.getSelectedChecbox
          .filter((item) => {
            if (item.type === 'Parada') {
              return item.id;
            }
          })
          .map((item) => item.id),
        deliveryIds: this.getSelectedChecbox
          .filter((item) => {
            if (item.type === 'Entrega') {
              return item.id;
            }
          })
          .map((item) => item.id),
        cargoIds: this.getSelectedChecbox
          .filter((item) => {
            if (item.type === 'Carga') {
              return item.id;
            }
          })
          .map((item) => item.id),
        boardingIds: this.getSelectedChecbox
          .filter((item) => {
            if (item.type === 'Embarque') {
              return item.id;
            }
          })
          .map((item) => item.id),
        nfeIds: this.getSelectedChecbox
          .filter((item) => {
            if (item.type === 'Nota Fiscal') {
              return item.id;
            }
          })
          .map((item) => item.id)
      };

      try {
        const data = await this.getReceiptsByHierarchies(body);

        for (let item of data) {
          try {
            if (item.linkDownload) {
              const imgBlob = await this.getSrcImageCanhoto(item.linkDownload);
              try {
                const dataFile = await this.toBase64(imgBlob);

                let newItem = {
                  ...item,
                  srcImage: dataFile
                };

                setTimeout(() => {
                  this.nfeCanhotos.push(newItem);
                }, 10);
              } catch (e) {
                console.error(e);
              }
            }
          } catch (e) {
            console.error(e);
          }
        }
        this.loading = false;
      } catch (e) {
        console.error(e);
      }
    },
    async getSrcImageCanhoto(endpoint) {
      try {
        const data = await this.getSrcImage(endpoint);

        return data;
      } catch (e) {
        console.error(e);
        this.errorsType = 'error';
        this.errors = ['Opss, algo deu errado!'];
        this.error500 = e;
      }
    },
    printReceipts() {
      window.print();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper-to-print {
  display: none;
}
@media print {
  #shipments-print {
    position: absolute;
    width: 100%;
    z-index: 999;
    background: #fff;
    left: 0;
    right: 0;
  }
  .print-wrapper {
    width: 100%;
  }
  .wrapper-to-print {
    display: inline-block;
  }
  img {
    max-width: 600px;
  }
}
</style>
